<template>
  <div class="col-12">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div
        class="row bg-light-gray border-radius--light pb-3 pt-1"
        style="border-radius: 5px 5px 0px 0px"
      >
        <div class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ errors }"
            name="Nombre del Asistente"
            rules="required"
          >
            <label class="input-label">Nombre del Asistente:</label>
            <CustomDropDown
              v-model="model.assistantName"
              :options="collections.assistants"
              :error="errors[0]"
              custom-error-msg="Favor seleccione el asistente."
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ errors }"
            name="Tipo de Asistente"
            rules="required"
          >
            <label class="input-label">Tipo de Asistente:</label>
            <CustomDropDown
              v-model="model.resourceType"
              :options="collections.resourceTypes"
              :error="errors[0]"
              custom-error-msg="Favor seleccione el tipo de asistente."
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ errors }"
            name="Cantidad de horas"
            rules="required"
          >
            <label class="input-label">Cantidad de horas:</label>
            <CustomDropDown
              v-model="model.dailyShift"
              :options="collections.dailyShifts"
              :error="errors[0]"
              custom-error-msg="Favor escriba la cantidad de horas."
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
            />
          </ValidationProvider>
        </div>
      </div>
      <div
        class="row bg-light-gray border-radius--light pb-3  pt-1"
        style="border-radius: 0px 0px 5px 5px"
      >
        <div
          class="col-12 col-md-2 offset-md-10 pl-3 pr-2 d-flex align-items-end justify-content-end"
        >
          <ActionButton
            variant="outline-danger m-1"
            :i="`fas fa-times-circle`"
            :responsive="true"
            @click="cancel"
          >
            Cancelar
          </ActionButton>
          <ActionButton
            variant="success m-1"
            :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
            :responsive="true"
            @click="handleSubmit(submit)"
          >
            {{ editting ? 'Guardar' : 'Añadir' }}
          </ActionButton>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { CustomDropDown } from '@/components/common';
import ActionButton from 'ActionButton';

const modelInitialState = () => ({
  id: 0,
  assistantName: null,
  resourceType: null,
  dailyShift: null,
});

export default {
  name: 'RequesterForm',
  components: {
    ActionButton,
    CustomDropDown,
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    collections: { type: Object, required: true },
  },
  data: () => ({ model: modelInitialState() }),
  methods: {
    submit() {
      this.$emit('submit', this.model, this.cancel);
    },
    cancel() {
      this.model = modelInitialState();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  created() {
    if (this.item) {
      this.model = { ...this.model, ...this.item };
    }
  },
};
</script>

<style lang="scss" scoped>
.input-label {
  color: #727272;
  font-size: 15px;
  font-weight: lighter;
}

.was-Invalidated {
  border: 1px solid red;
}
</style>
